<script setup lang="ts">
import { ATextInput } from '../generics'
import type { TableFilterOptions, TableFilterValueOptions } from '.'

const model = defineModel<TableFilterValueOptions>({ default: { operator: 'equal', values: [] }, required: true })

defineProps<{
  filter: TableFilterOptions
}>()
</script>

<template>
  <div class="atabix-table-filter-section">
    <ATextInput v-model="model.values[0]" :placeholder="filter.placeholder" :type="filter.type || 'text'" />
  </div>
</template>

<style scoped lang="scss"></style>
